import { render, staticRenderFns } from "./StepConnectExtensions.vue?vue&type=template&id=f206619c&scoped=true&"
import script from "./StepConnectExtensions.vue?vue&type=script&lang=js&"
export * from "./StepConnectExtensions.vue?vue&type=script&lang=js&"
import style0 from "./StepConnectExtensions.vue?vue&type=style&index=0&id=f206619c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f206619c",
  null
  
)

export default component.exports